import env from '@config/env';

const appConfig = {
  name: env.APP_NAME,
  version: env.VERSION,
  environment: env.ENV,
  webAppUrl: env.WEB_APP_URL.replace(/\/$/, ''),
  forgotPasswordUrl: `${env.WEB_APP_URL.replace(/\/$/, '')}/forgot-password`,
  defaultLocale: 'en-US',
  defaultTimezone: 'UTC',
  pageSizeOptions: [10, 25, 50, 100],
  defaultPageSize: 25,
  toastDuration: 4000,
  debounceDelay: 300,
};

export default appConfig;
